import { useState } from "react";
import { createRoot } from "react-dom/client";
import Modal from "./modal";

const CustomPrompt = ({ question, onResolve }) => {
    const [input, setInput] = useState("");
    const handleSubmit = () => {
      onResolve(input);
    };
    const handleCancel = () => {
      onResolve(null);
    };
    return (
      <Modal
        closeIt = {() => handleCancel()}
        handleFormSubmit = {() => handleSubmit(input)}
        actionKey = {"Confirm"}
        width = {"40rem"}
      >
            <label className = "font-weight-bold my-2">{question}</label>
            <input
                className = "form-control w-100 mb-3"
                value = {input}
                onChange = {e => setInput(e.currentTarget.value)}
            />
      </Modal>
    );
};
  
export const customPrompt = (question) => {
    return new Promise((resolve) => {
        const container = document.createElement("div");
        const parent = document.body;
        parent.appendChild(container);
        const root = createRoot(container);
        const handleResolve = (value) => { 
            root.unmount();
            parent.removeChild(container);
            resolve(value);
        };
        root.render(<CustomPrompt question = {question} onResolve = {handleResolve}></CustomPrompt>);
    });
};